<form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
  <label for="email" class="block text-sm font-medium text-[#172C41] mb-1">Correo Electrónico</label>
  <input
    id="email"
    type="email"
    formControlName="email"
    placeholder="ejemplo@sitrack.mx"
    [disabled]="disabled()"
    class="w-full rounded-[4px] border border-gray-300 px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E] disabled:opacity-50 disabled:cursor-not-allowed"
  />
  @if (emailForm.get('email')?.invalid && emailForm.get('email')?.touched) {
    <small class="text-red-500 block mt-1 mb-3 text-left text-sm">
      Por favor, ingrese un correo electrónico válido.
    </small>
  } @else {
    <div class="mb-5 mt-1"></div>
  }

  <button
    type="submit"
    [disabled]="emailForm.invalid || disabled()"
    class="w-full px-4 py-2 rounded-[4px] font-medium bg-[#F99C1E] text-white cursor-pointer transition-colors hover:bg-[#e08a12] disabled:opacity-50 disabled:cursor-not-allowed"
  >
    Solicitar OTP
  </button>
</form>
